import { render } from "./IconMenuCarrier.vue?vue&type=template&id=f1c64290"
import script from "./IconMenuCarrier.vue?vue&type=script&lang=ts"
export * from "./IconMenuCarrier.vue?vue&type=script&lang=ts"
script.render = render

export default script